import { Checkbox, FormControlLabel, FormControlLabelProps, Typography } from "@mui/material";
import { forwardRef } from "react";

export type CheckBoxProps = Omit<FormControlLabelProps, "control"> & {
    indeterminate?: boolean,
    size?: "small" | "medium"
};

const CheckBox = forwardRef(({
    indeterminate,
    size = "medium",
    label,
    ...props
}: CheckBoxProps, ref) => {
    return <FormControlLabel
        {...props}
        ref={ref}
        control={<Checkbox size={size} indeterminate={indeterminate} />}
        label={<Typography variant={size == "medium" ? "body1" : "body2"} color={props.disabled ? "textDisabled" : "textPrimary"}>{label}</Typography>}
        sx={{ marginLeft: 0, ...props.sx }}
    />
})

export default CheckBox;